export default __webpack_public_path__ + "static/media/SWT0090.34I-21360_-16379_0.ad6d9007.jpg";